<template>
    <Page>
        <PageHeaderFull title="Benvenuto" :titleUnderline="companyName">
            <template #secondary-actions>
                <K3ColContainer col1Class="p-1" col2Class="p-1" col3Class="p-1">
                    <template #col1>
                        Codice Cassa Edile: <span v-if="companyData && companyData.eduCompany" class="first-col-label">{{ companyData.eduCompany?.extCode1 }}</span>
                    </template>
                    <template #col2 v-if="companyData?.responsabileSicurezzaLavoratori">
                        <strong>RLS: </strong>{{companyData.responsabileSicurezzaLavoratori.eduWorker.name}} {{companyData.responsabileSicurezzaLavoratori.eduWorker.lastName}}
                        <div class="state-code inline-block mr-3" :class="`bg-success`"></div>
                        <div class="accordion-body p-0 inline-block">
                            Regolarità Amministrativa: <span class="second-col-label">In regola</span>
                        </div>
                    </template>
                    <template #col3>
                        <!-- TODO: RLS/RLST -->
                    </template>
                </K3ColContainer>
            </template>
        </PageHeaderFull>

        <div>
            <p style="margin-top: 1rem; text-align: end;">DATI AGGIORNATI AL 03/02/2023</p>
        </div>
        <div class="row my-4">
            <div class="col-12 p-0">
                <div class="mb-2">
                    <span class="notify-title">Notifiche</span>
                </div>
                <!-- <button value="modal" @click="testmodal"></button> -->
                <KNotificationCard
                    v-if="showExpiredCoursesNotification"
                    title="Corsi"
                    body="Sono presenti dei corsi scaduti"
                    showPrimaryButton
                    showSecondaryButton
                    :primaryButton="{ label: 'DETTAGLI' }"
                    :secondaryButton="{ label: 'RICORDAMELO PIU\' TARDI ' }"
                    level="danger"
                    @on-primary-button-click="router.push({path: `/course`})"
                    @on-secondary-button-click="showExpiredCoursesNotification = false">
                </KNotificationCard>
                <CesfNotificationCard v-for="notifica in multichannelNotificationsStore.notifications" :key="notifica.id" :notifica="notifica" />
                <span v-if="multichannelNotificationsStore.notifications.length == 0 && !showExpiredCoursesNotification"> Nessuna notifica presente al momento. </span>
            </div>
        </div>

        <div class="row my-4">
            <div class="col-12 p-0">

                <KTabs>
                    <!-- <KTab name="Corsi" :higlightCounter="coursesExpired">
                        <DataTable :value="corsiItems" dataKey="id" responsiveLayout="scroll" :loading="loading">
                            <Column header="CORSO">
                                <template #body="slotProps">
                                    <div v-if="isStateVisible(slotProps.data)" class="bg-primary state-code-label inline-block mr-3" />
                                    {{slotProps.data.corso}}
                                </template>
                            </Column>
                            <Column header="INIZIO CORSO">
                                <template #body="slotProps">
                                    {{toDateString(slotProps.data.inizioCorso)}}
                                </template>
                            </Column>
                            <Column header="SCADENZA">
                                <template #body="slotProps">
                                    {{toDateString(slotProps.data.dataScadenza)}}
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <div style="text-align: right">
                                        <button type="button" class="btn btn-outline-primary"
                                            @click="goToCourseDetail()"> SCOPRI DI PIU' </button>
                                    </div>
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <div style="text-align: right">
                                        <button type="button" class="btn btn-primary"
                                            @click="goToIscrizioneCorso(slotProps.data)"> ISCRIVITI </button>
                                    </div>
                                </template>
                            </Column>
                            <template #empty> Nessun corso trovato </template>
                        </DataTable>
                    </KTab> -->
                    <KTab name="Cantieri">
                        <DataTable :value="cantieriItems" dataKey="id" responsiveLayout="scroll" :loading="loading">
                            <Column field="comune" header="COMUNE" />
                            <Column field="tipologia" header="TIPOLOGIA" />
                            <Column header="INIZIO">
                                <template #body="slotProps">
                                    {{toDateString(slotProps.data.dataInizio)}}
                                </template>
                            </Column>
                            <Column header="FINE">
                                <template #body="slotProps">
                                    {{toDateString(slotProps.data.dataFine)}}
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <div style="text-align: right">
                                        <button type="button" class="btn btn-primary"
                                            @click="goToCantiereDetail(slotProps.data)"> DETTAGLI </button>
                                    </div>
                                </template>
                            </Column>
                            <template #empty> Nessun cantiere trovato </template>
                        </DataTable>
                    </KTab>
                    <KTab name="Circolari e Comunicazioni">
                        <DataTable :value="circolariItems" dataKey="id" responsiveLayout="scroll" :loading="loading">
                            <Column field="name" header="TITOLO"></Column>
                            <Column header="DATA PUBBLICAZIONE">
                                <template #body="slotProps">
                                    {{toDateString(slotProps.data.publishedDate)}}
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <div style="text-align: right">
                                        <a target="_blank" role="button" class="btn btn-primary" :href="(link+slotProps.data.url)"> DETTAGLI </a>
                                    </div>
                                </template>
                            </Column>
                            <template #empty> Nessuna circolare o comunicazione </template>
                        </DataTable>
                    </KTab>
                </KTabs>
            </div>
        </div>

        <!-- <div class="row my-4">
            <div class="col-12 p-0">
                <h3 class="vantaggi-opportunita-title">Vantaggi e opportunità</h3>
            </div>
            <div class="col-12 p-0">
                <K3ColContainer col1Class="p-3" col2Class="p-3" col3Class="p-3">
                    <template #col1>
                        <KCard :title="'Verifica documentazione aziendale sulla sicurezza Verifica documentazione aziendale sulla sicurezza Verifica documentazione aziendale sulla sicurezza Verifica documentazione aziendale sulla sicurezza'"
                                :showDetailButton="true"
                                :showCmdButton="true"
                                :labelDetailButton="'SCOPRI DI PIU'"
                                :labelCmdButton="'ISCRIVITI'"
                                :eventCmdButton="goToCourseDetail">

                        </KCard>
                    </template>
                    <template #col2>
                        <KCard :title="'Verifica documentazione aziendale sulla sicurezza'"
                                :showDetailButton="true"
                                :showCmdButton="true"
                                :labelDetailButton="'SCOPRI DI PIU'"
                                :labelCmdButton="'ISCRIVITI'"
                                :eventCmdButton="goToCourseDetail">

                        </KCard>
                    </template>
                    <template #col3>
                        <KCard :title="'Verifica documentazione aziendale sulla sicurezza'"
                                :showDetailButton="true"
                                :showCmdButton="true"
                                :labelDetailButton="'SCOPRI DI PIU'"
                                :labelCmdButton="'ISCRIVITI'"
                                :eventCmdButton="goToCourseDetail">

                        </KCard>
                    </template>
                </K3ColContainer>
            </div>
        </div> -->

        <BannerEsperto />

        <div class="row my-4">
            <div class="col-8">
                <KSectionHeader title="Ultime dal settore" />
                <div class="col-12 p-0">
                    <K2ColContainer :col1Class="'p-3'" :col2Class="'p-3'">
                        <template v-if="news1" #col1>
                            <div class="card-wrapper">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="category-top">
                                            <a class="category text-uppercase" href="#">{{news1.title}}</a>
                                        </div>
                                        <h5 class="card-title ">{{news1.description}}</h5>
                                        <a target="_blank" class="read-more" :href="news1.url" role="button" :title="news1.title">
                                            <span class="text">SCOPRI DI PIU'
                                                <span class="visually-hidden">Verifica documentazione aziendale sulla sicurezza</span>
                                            </span>
                                            <KIcon class="icon-primary icon-xs" icon="it-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-if="news2" #col2>
                            <div class="card-wrapper">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="category-top">
                                            <a class="category text-uppercase" href="#">{{news2.title}}</a>
                                        </div>
                                        <h5 class="card-title ">{{news2.description}}</h5>
                                        <a target="_blank" :href="news2.url" class="read-more" role="button" :title="news2.title">
                                            <span class="text">SCOPRI DI PIU'
                                                <span class="visually-hidden">Verifica documentazione aziendale sulla sicurezza</span>
                                            </span>
                                            <KIcon class="icon-primary icon-xs" icon="it-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </K2ColContainer>
                </div>
            </div>
            <div class="col-4">
                <KSectionHeader title="WebTV" />
                <div class="col-12 p-0">
                    <KWebTvLatest></KWebTvLatest>
                </div>
            </div>
        </div>
    </Page>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
import { useFilters, useUserStore, cmsService } from "@k-digitale/kappa";

//IMPORT MODELS
import { useCesfUser, useViewStatus } from "@/composables";
import { CompanyExtension } from "@/services/learningExtensions/models";
import { learningExtensionService } from "@/services/learningExtensions/LearningExtensionsServices";
import { learningWrappersService } from "../services/learningWrappers/LearningWrappersServices";
import { cesfService } from "@/services/cesf/CesfServices";
import { Cantiere, CantiereFinder, CesfNotification } from "@/services/cesf/models";
import { CourseInstanceFinder, CourseParticipationOutcome, CourseParticipationOutcomeFinder, CourseParticipationOutcomeStatus, CourseParticipationOutcomeValidityStatus } from "@/learning/instances/models";

//IMPORT STORES
import { useBuildingSiteStore } from "@/modules/buildingsite/store";
import { useMultichannelNotificationsStore } from "@/modules/multichannelNotifications/store";
import { useCourseStore } from "@/modules/course/store";
import { useCesfCmsStore } from "@/store"

import KWebTvLatest from "@/modules/webtv/pages/KWebTvLatest.vue";
import BannerEsperto from "@/components/BannerEsperto.vue";
import CesfNotificationCard from "@/components/CesfNotificationCard.vue";
import { CourseParticipationOutcomeWrapper, CourseTemplateTagType } from "@/services/learningWrappers/Models";

const { isUserCompany, cesfUser } = useCesfUser();
const viewStatusHelper = useViewStatus();

const router = useRouter();
const { toDDMMMMString, toDateString } = useFilters();
const { user } = useUserStore();

//STORES
const cesfCmsStore = useCesfCmsStore();
const coursesStore = useCourseStore();
const buildingSiteStore = useBuildingSiteStore();

//REFS
const loading = ref(true);
const corsiItems = ref<any[]>([]);
const showExpiredCoursesNotification = ref(false);

//COMPUTED
const circolariItems = computed(() => {
    return cesfCmsStore.circolari.sort((a,b) => {
        return new Date(b.publishedDate).getTime() - new Date(a.publishedDate).getTime();
    })
});

const link = computed(() => import.meta.env.VITE_CMS_DETAIL_BASE_URL);
const newsByPublishDate = computed(() => {
    return cesfCmsStore.news.sort((a,b) => {
        return new Date(b.publishedDate).getTime() - new Date(a.publishedDate).getTime();
    });
})
const news1 = computed(() => {
    if(newsByPublishDate.value.length < 1){
        return null;
    }
    const news = newsByPublishDate.value[0];
    return {
        title: news.name,
        description: news.contents.find(c => c.code == "text")?.value.value,
        url: import.meta.env.VITE_CMS_DETAIL_BASE_URL+news.url,
    };
});
const news2 = computed(() => {
    if(newsByPublishDate.value.length < 2){
        return null;
    }
    const news = newsByPublishDate.value[1];
    return {
        title: news.name,
        description: news.contents.find(c => c.code == "text")?.value.value,
        url: import.meta.env.VITE_CMS_DETAIL_BASE_URL+news.url,
    };
});

const cantieriItems = computed(() =>
    cantieri.value.map(c => {
        return {
            id: c.id,
            comune: `${c.comuneISTAT} (${c.provinciaISTAT})`,
            tipologia: c.tipologiaDeiLavori,
            dataInizio: c.dataPresuntoInizio,
            dataFine: c.dataPresuntaFine
        };
    })
);

const coursesExpired = computed(() => {
    return corsiItems.value.filter(function (x: any) {
        return viewStatusHelper.isExpiredOrInExpiring(x.dataScadenza);
    }).length;
});

//VUE
// onMounted(async () => {

//     if(isUserCompany.value){
//         loading.value = true;

//         companyData.value = await learningExtensionService.getCompanyExtByEduCompanyId(cesfUser.value.companyId);
//         await Promise.all([
//             loadCantieri(),
//             loadCorsiItems(),
//             cesfCmsStore.getCircolari(),
//             cesfCmsStore.getNews(),
//             loadNotifications()
//         ]);

//         loading.value = false;
//     }

// });

const companyData = ref<CompanyExtension>();
const companyName = computed(() => {
    if(companyData.value) {
        return companyData.value.eduCompany.businessName;
    }
    return '';
})

watch(() => isUserCompany.value, async () => {
    if(isUserCompany.value){
        loading.value = true;

        companyData.value = await learningExtensionService.getCompanyExtByEduCompanyId(cesfUser.value.companyId);
        await Promise.all([
            loadCantieri(),
            loadCorsiItems(),
            cesfCmsStore.getCircolari(),
            cesfCmsStore.getNews(),
            loadNotifications(),
            loadCourseOutcomes(),
        ]);

        loading.value = false;
    }
}, { immediate: true })

const cantieri = ref<Cantiere[]>([]);
const loadCantieri = async (pageNumber : number = 1) => {
    const finder = {
        pageIndex: pageNumber,
        pageSize: 10
    } as CantiereFinder;
    if(isUserCompany.value){
        const result = await buildingSiteStore.getCantieriByCompany(finder, cesfUser.value.companyId);
        cantieri.value = result.items;
    }
}

const multichannelNotificationsStore = useMultichannelNotificationsStore();
const loadNotifications = async () => {

    const response = await multichannelNotificationsStore.getUserNotifications(1, 2);
}

const loadCourseOutcomes = async () => {
    if(isUserCompany){
        const courseParticipationsResponse =
            await learningWrappersService.getCourseParticipationOutcomesWrappersForActualCompanyStudents(
                cesfUser.value.companyId,
                {
                queryRegistriesRelations: true,
                pageIndex: -1,
                pageSize: -1,
                status: CourseParticipationOutcomeStatus.Success,
                validityStatus: CourseParticipationOutcomeValidityStatus.Active,
                sortOrder: -1
            } as CourseParticipationOutcomeFinder);

        if(courseParticipationsResponse.items.length > 0){
            let fathers = courseParticipationsResponse.items.filter(o  => o.fathersCourseTemplates.length == 0 && o.validityStatus == CourseParticipationOutcomeValidityStatus.Active);
            const groupedParticipations = fathers.reduce((acc : any, obj : CourseParticipationOutcome) => {
                const key = obj.relatedCourseTemplateId;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
            }, {});
            for (var key of Object.keys(groupedParticipations)) {
                const group = groupedParticipations[key];
                const outcome = (group[0] as CourseParticipationOutcomeWrapper);
                if(outcome.relatedTemplateTags && outcome.relatedTemplateTags.some(t => t == CourseTemplateTagType.Main)){
                    if(dayjs() > dayjs(outcome.expiryDate)){
                        showExpiredCoursesNotification.value = true;
                        return;
                    }
                }
            }
            //Raggruppo per i corsi base padre
            let fathersRelatedCourseTemplatesId = fathers.map(f => f.relatedCourseTemplateId);
            let orphans = courseParticipationsResponse.items.filter(o => o.fathersCourseTemplates.length > 0 && !o.fathersCourseTemplates.some(ct => fathersRelatedCourseTemplatesId.includes(ct)));
            let groupedOrphansByFather = orphans.reduce((acc : any, obj : CourseParticipationOutcomeWrapper) => {
                const key = obj.fathersCourseTemplates[0];
                if (!acc[key]) {
                    acc[key] = [];
                }

                acc[key].push(obj);
                return acc;
            }, {});

            for (var fatherKey of Object.keys(groupedOrphansByFather)) {
                const groupByFather = groupedOrphansByFather[fatherKey];

                //Raggruppo il sottogruppo per studente in modo da calcolarmi gli aggiornamenti più recenti
                let groupedOrphansByStudents = groupByFather.reduce((acc : any, obj : CourseParticipationOutcomeWrapper) => {
                    const key = obj.courseParticipation.studentId;
                    if (!acc[key]) {
                        acc[key] = [];
                    }

                    acc[key].push(obj);
                    return acc;
                }, {});
                const studentsOrphansActiveCourses = [] as CourseParticipationOutcomeWrapper[];
                for(var studentKey of Object.keys(groupedOrphansByStudents)){
                    const groupByStudent = groupedOrphansByStudents[studentKey];
                    const sortedGroup = (groupByStudent as CourseParticipationOutcomeWrapper[]).sort((a,b) => {
                        return new Date(b.courseDate).getTime() - new Date(a.courseDate).getTime();
                    });
                    studentsOrphansActiveCourses.push(sortedGroup[0]);
                }

                //Infine raggruppo i restanti gruppi per relativo template per avere i corsi da mostrare
                let groupedOrphansByRelatedCourse = studentsOrphansActiveCourses.reduce((acc : any, obj : CourseParticipationOutcomeWrapper) => {
                    const key = obj.relatedCourseTemplateId;
                    if (!acc[key]) {
                        acc[key] = [];
                    }

                    acc[key].push(obj);
                    return acc;
                }, {});

                for(var relatedCourseKey of Object.keys(groupedOrphansByRelatedCourse)){
                    const groupByRelatedCourse = groupedOrphansByRelatedCourse[relatedCourseKey];
                    for( var outcome of groupByRelatedCourse){
                        const courseDate = new Date(outcome.courseDate);
                        const validityMonths = outcome.relatedCourseTemplate.validityMonths;
                        outcome.expiryDate = new Date((courseDate.setMonth(courseDate.getMonth()+validityMonths)));
                        if(dayjs() > dayjs(outcome.expiryDate)){
                            showExpiredCoursesNotification.value = true;
                            return;
                        }
                    }
                }

            }
        }


    }
}

const goToCantiereDetail = (cantiere : Cantiere) => {
    router.push({
            path: `/buildingsite/detail/${cantiere.id}`
        });
}

const loadCorsiItems = async (pageNumber : number = 1) => {
    const startingCoursesFinder = {
        pageIndex: 1,
        pageSize: 10,
        queryRelations: true,
    } as CourseInstanceFinder;
    const startingCourses = await coursesStore.getStartingCourses(startingCoursesFinder);

    const companyOutcomesFinder = {
        pageIndex: -1,
        pageSize: -1,
        status: CourseParticipationOutcomeStatus.Success,
        validityStatus: CourseParticipationOutcomeValidityStatus.Active,
    } as CourseParticipationOutcomeFinder;
    const courseCompanyOutcomes = await coursesStore.getCompanyCourseOutcomesByFinder(cesfUser.value.companyId, companyOutcomesFinder);
    corsiItems.value = startingCourses.map(sc => {
        const outcomes = courseCompanyOutcomes.filter(co => co.relatedCourseTemplateId == sc.courseTemplateId);
        let result = {
            id: sc.id,
            corso: sc.template.title,
            inizioCorso: sc.startDate,
            dataScadenza: outcomes.length > 0 ?
                outcomes.reduce((prev, curr) => {
                    if(!curr.doesExpire) return curr;
                    return curr.expiryDate < prev.expiryDate ? curr : prev;
                }).expiryDate : null,
        };
        return result;
    });
}



const goToCircolareDetail = (item: any) => {
    router.push({
        path: `/communication/detail/${item.id}`
    });
};

const isStateVisible = (item: any) => {
    return viewStatusHelper.isExpiredOrInExpiring(item.dataScadenza);
};

const goToIscrizioneCorso = (item: any) => {
    // router.push({
    //     path: `/employee/detail/${item.id}`
    // });
};

const goToCourseDetail = () => {
    router.push({
        path: `/course/registration`,
    });
};

</script>

<style scoped lang="scss">

.first-col-label {
    background-color: #e3e3e3;
    border-radius: 5px;
    padding: 0px 5px;
}
.third-col-label {
    color: #0066cc;
}
.second-col-label {
    color: #00ba07;
}
.state-code {
    background-color: #00ba07 !important;
    width: 14px;
    height: 14px;
    border-radius: 8px;
}
.notify-title {
    font-size: 28px;
}
.tabview-custom {
    i,
    span {
        vertical-align: middle;
    }

    span {
        margin: 0 0.5rem;
    }
}

.p-tabview p {
    line-height: 1.5;
    margin: 0;
}
.state-code-label {
    width: 12px;
    height: 12px;
    border-radius: 6px;
}
.tb-lista-corsi-home,
.tb-lista-cantieri-home {
    .p-datatable-wrapper {
        table {
            tbody {
                tr {
                    td:first-child {
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>
